import React from 'react';
import BattleSprite, { resolveSpriteSheetLayout } from '../BattleSprite';

export const WIKI_SPRITE_MAX = 60;

export function wikiSpriteFitScale(sheet, max = WIKI_SPRITE_MAX) {
  const { fw, fh } = resolveSpriteSheetLayout(sheet);
  if (fw <= 0 || fh <= 0) return 1;
  return Math.min(1, max / fw, max / fh);
}

const WikiBattleSprite = ({
  sheet,
  className = '',
  maxSize = WIKI_SPRITE_MAX,
  playing = true,
  loop = true,
  fallbackLabel = '',
}) => {
  if (!sheet?.url) return null;

  const scale = wikiSpriteFitScale(sheet, maxSize);

  return (
    <div
      className="wiki-monster-sprite-wrap"
      style={{ width: maxSize, height: maxSize }}
    >
      <div
        className="wiki-monster-sprite-scaler"
        style={{ '--wiki-sprite-scale': scale }}
      >
        <BattleSprite
          sheet={sheet}
          playing={playing}
          loop={loop}
          className={className}
          fallbackLabel={fallbackLabel}
        />
      </div>
    </div>
  );
};

export default WikiBattleSprite;
